import { Component, OnInit, RendererFactory2, Renderer2, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import dayjs from 'dayjs/esm';

import { AccountService } from 'app/core/auth/account.service';
import { HttpResponse } from '@angular/common/http';
import { ICbicMenuMst } from 'app/entities/cbic-menu-mst/cbic-menu-mst.model';
import { CbicMenuMstService } from 'app/entities/cbic-menu-mst/service/cbic-menu-mst.service';
import { ElementRef } from '@angular/core';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { SessionStorageService } from 'ngx-webstorage';
import { ThemeService } from 'app/core/util/theme.service';

@Component({
  selector: 'cbic-main',
  templateUrl: './main.component.html',
})
export class MainComponent implements OnInit {
  selectedMenu = this.getSelectedMenu();
  menuList: any;
  color: any;
  public pathname: string | undefined;

  hoveredText: string | null = null;
  readAloudEnabled = false;
  @ViewChild('mainContent') mainContent!: ElementRef;

  private lastSpoken = '';
  private highlightEl: HTMLElement | null = null;

  private renderer: Renderer2;
  

  constructor(
    private sessionStorageService: SessionStorageService,
    private accountService: AccountService,
    private titleService: Title,
    private router: Router,
    private translateService: TranslateService,
    private menuService: CbicMenuMstService,
    private contentMstService: CbicContentMstService,
    rootRenderer: RendererFactory2, private _elementRef: ElementRef,
    public theme: ThemeService
  ) {
    this.renderer = rootRenderer.createRenderer(document.querySelector('html'), null);
  }

  ngOnInit(): void {
    this.color = this.sessionStorageService.retrieve('colr');
    this._elementRef.nativeElement.removeAttribute("ng-version");
    // try to log in automatically
    this.pathname = window.location.pathname;
    this.accountService.identity().subscribe();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateTitle();
      }
    });

    this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.updateTitle();
      dayjs.locale(langChangeEvent.lang);
      this.renderer.setAttribute(document.querySelector('html'), 'lang', langChangeEvent.lang);
    });
    // alert("adding interval... "); \

    setInterval(() => {
      // alert("executing");
      this.contentMstService.getContentRefresh();
      //  }, 2.5*60*1000);
    }, 15000);
    this.fetchMenuList();
    this.menuService.selectedMenu.subscribe(selectedMenu=>{
      this.selectedMenu = selectedMenu;
    });
  }


toggleReadAloud() {
    this.readAloudEnabled = !this.readAloudEnabled;
    window.speechSynthesis.cancel();
  }

  // Called on mouseover of any text element
  onTextHover(text: string) {
    if (this.readAloudEnabled) {
      this.speak(text);
    }
  }

  // Dynamically read text on hover for any element
  onDynamicTextHover(event: MouseEvent) {
    if (!this.readAloudEnabled) {return};
    const target = event.target as HTMLElement;
    if (!target) {return};
    const tag = target.tagName.toLowerCase();
    // Allow reading button text too
    if (["input", "img", "svg", "path"].includes(tag)) {return};
    let text = '';
    if (tag === 'button') {
      text = target.innerText?.trim() ?? target.getAttribute('aria-label') ?? '';
    } else {
      text = target.innerText?.trim();
    }
    if (text && text !== this.lastSpoken && text.length > 1) {
      this.lastSpoken = text;
      this.speak(text);
    }
  }

  speak(text: string | null, onEnd?: () => void) {
    console.log('Speak called with:', text); // Debug log
    if (!text) {return};
    // Check for browser support
    if (!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) {
      alert('Sorry, your browser does not support text-to-speech.');
      {return};
    }
    // Stop any ongoing speech
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
    // Remove setTimeout for immediate execution
    const utter = new window.SpeechSynthesisUtterance(text.trim());
    utter.lang = 'en-US';
    utter.rate = 1; // Normal speed
    utter.volume = 1; // Max volume
    utter.pitch = 1; // Normal pitch
    // Add onend and onerror for debugging
    utter.onend = () => {
      if (onEnd) {onEnd();}
    };
    utter.onerror = (e) => {
      if (onEnd) {onEnd();}
    };
    window.speechSynthesis.speak(utter);
  }






  fetchMenuList(): void {
    this.menuService.findByIsActive().subscribe(
      (res: HttpResponse<ICbicMenuMst[]>) => {
        if (res.body) {
          this.menuList = res.body;
          this.menuService.updateSelectedMenu(this.menuList[0]);
        }
      }
    )
  }

  getSelectedMenu(): any {
    console.log(this.menuService.getSelectedMenu());
    return this.menuService.getSelectedMenu();
  }
  updateSelectedMenu(selectedMenu: any) {
    this.menuService.updateSelectedMenu(selectedMenu);
  }
  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
    const title: string = routeSnapshot.data['pageTitle'] ?? '';
    if (routeSnapshot.firstChild) {
      return this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }

  private updateTitle(): void {
    let pageTitle = this.getPageTitle(this.router.routerState.snapshot.root);
    if (!pageTitle) {
      pageTitle = 'global.title';
    }
    this.translateService.get(pageTitle).subscribe(title => this.titleService.setTitle(title));
  }
}